import { NgModule } from '@angular/core';

import { MinuteSecondsPipe } from './minutesSeconds.pipe';
import { SecondsAgoPipe } from './secondsAgo.pipe';
import { FileSizePipe } from './fileSize.pipe';
import {SafePipe} from './safe.pipe';

@NgModule({
  declarations: [
    FileSizePipe,
    MinuteSecondsPipe,
    SecondsAgoPipe,
    SafePipe
  ],
  imports: [],
  exports: [
    FileSizePipe,
    MinuteSecondsPipe,
    SecondsAgoPipe,
    SafePipe
  ]
})
export class AITPipesModule {}
